module.exports = __webpack_public_path__ + "img/loading.1a940299.gif";